// Utils
import { shouldShowAnniversaryBadge, calculateEngagement } from '@/utils';

// Constants
import { SCENE_2_CONFIG } from './constants';

/**
 * Calculate Scene 2 duration based on whether anniversary effects should be shown
 */
export const calculateScene2Duration = (onboardingDate: string): number => {
  const { years } = calculateEngagement(onboardingDate);
  const showAnniversary = shouldShowAnniversaryBadge(years);

  return showAnniversary
    ? SCENE_2_CONFIG.DURATION
    : SCENE_2_CONFIG.DURATION_WITHOUT_ANNIVERSARY;
};
